import TagManager from "react-gtm-module";

function NeedSomeHelpButton({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "need_some_help_button",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default NeedSomeHelpButton;
